import React, { Suspense, useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'

class ChunkErrorBoundary extends React.Component {
  componentDidCatch(error) {
    if (error?.name === 'ChunkLoadError') {
      window.location.reload()
    }
  }
  render() {
    return this.props.children
  }
}

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const ForgotPassword = React.lazy(() => import('./views/pages/forgotPassword/Forgotpassword'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const PasswordReset = React.lazy(() => import('./views/pages/forgotPassword/PasswordReset'))

const AdminSelectCompany = React.lazy(() => import('./views/pages/login/SelectCompany'))

const App = () => {
  useEffect(() => {
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Notification permission granted.')
        }
      })
    } else {
      console.warn('Notifications are not supported on this device.')
    }
  }, [])

  return (
    <BrowserRouter>
      <ChunkErrorBoundary>
        <Suspense fallback={loading}>
          <Routes>
            {['/', 'login'].map((path, index) => (
              <Route exact path={path} name="Login Page" key={index} element={<Login />} />
            ))}
            <Route exact path="/forgot" name="Forgot Password" element={<ForgotPassword />} />
            <Route
              exact
              path="/password-reset"
              name="Forgot Password"
              element={<PasswordReset />}
            />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="*" name="Home" element={<DefaultLayout />} />
            <Route
              exact
              path="/selectcompany"
              name="Selecionar Empresa"
              element={<AdminSelectCompany />}
            />
          </Routes>
        </Suspense>
      </ChunkErrorBoundary>
    </BrowserRouter>
  )
}

export default App
